import React from 'react';

// Shown when the API could not get templates from Twilio and served the hardcoded defaults
export default function TemplatesFallbackNotice({ reason, className = '' }: { reason?: string; className?: string }) {
    return (
        <div
            className={`rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-700 dark:border-amber-900/50 dark:bg-amber-900/20 dark:text-amber-300 ${className}`}
        >
            <span className="font-medium">Templates par défaut affichés</span> — impossible de récupérer les templates Twilio
            {reason ? ` (${reason})` : ''}.
        </div>
    );
}
